export default "__VITE_ASSET__CNp3uoaS__"